// removed by extract-text-webpack-plugin
module.exports = {"actions":"j8_ir","bookNow":"j8_hc","button":"j8_bp","heartButton":"j8_j9","shareButton":"j8_ka _1kB_d9laDuyaX1azPOvneD j8_bp j8_j9","shareIcon":"j8_kb","shareText":"j8_kc"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventHeader/Actions/styles.module.css
// module id = 1281
// module chunks = 27